import { PaddedContainer } from '@/atoms/PaddedContainer'

interface CollectionHeaderProps {
  title: string
}

/**
 * Renders a collection title as a header, styled to match the Contentful Header component.
 * This enables translated titles from the CollectionService to replace untranslated Contentful Headers.
 */
export function CollectionHeader({ title }: CollectionHeaderProps) {
  return (
    <PaddedContainer className="-mb-8 overflow-x-hidden" fluid>
      <header className="relative">
        <h2 className="m-0 p-0 text-left font-angelSans text-2xl/[1.25] font-bold text-white">{title}</h2>
      </header>
    </PaddedContainer>
  )
}
